import type { PaymentDistribution } from "../../../hooks/api/useGetCalculationById";

export type PensionGroup = "private" | "occupational" | "public";

export interface PensionSegment {
  key: string;
  label: string;
  percentage: number;
  group: PensionGroup;
  hatched: boolean;
}

type SegmentSpec = Omit<PensionSegment, "percentage"> & {
  field: keyof PaymentDistribution;
};

const SPECS: SegmentSpec[] = [
  {
    key: "private",
    field: "P_Percentage",
    label: "Privat pension",
    group: "private",
    hatched: true,
  },
  {
    key: "occupationalDc",
    field: "T_DC_Percentage",
    label: "Premiebestämd",
    group: "occupational",
    hatched: true,
  },
  {
    key: "occupationalNonDc",
    field: "T_NonDC_Percentage",
    label: "Förmånsbestämd",
    group: "occupational",
    hatched: false,
  },
  {
    key: "ppm",
    field: "PPM_Percentage",
    label: "Premiepension",
    group: "public",
    hatched: true,
  },
  {
    key: "income",
    field: "I_Percentage",
    label: "Inkomstpension",
    group: "public",
    hatched: false,
  },
  {
    key: "guarantee",
    field: "G_Percentage",
    label: "Garantipension",
    group: "public",
    hatched: false,
  },
];

export function buildSegments(
  distribution: PaymentDistribution,
  publicOnly = false,
): PensionSegment[] {
  return SPECS.filter((spec) => !publicOnly || spec.group === "public").flatMap(
    ({ field, ...segment }) => {
      const percentage = distribution?.[field];
      // A slice that rounds to 0 % would render a labelled block claiming no share.
      if (typeof percentage !== "number" || Math.round(percentage) <= 0) {
        return [];
      }
      return [{ ...segment, percentage }];
    },
  );
}
